// Copyright (c) 2021. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { findIndex } from "../../../../../../io/hyperify/core/functions/findIndex";
import { forEach } from "../../../../../../io/hyperify/core/functions/forEach";
import { has } from "../../../../../../io/hyperify/core/functions/has";
import { isEqual } from "../../../../../../io/hyperify/core/functions/isEqual";
import { map } from "../../../../../../io/hyperify/core/functions/map";
import { ProductTableItemDataModel } from "../../../../../../io/hyperify/core/store/types/product/ProductTableItemDataModel";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import { Loader } from "../../../../../../io/hyperify/frontend/components/loader/Loader";
import { PRODUCT_TABLE_ITEM_DATA_CLASS_NAME } from "../../../../core/constants/className";
import { ProductFeatureData } from "./ProductFeatureData";
import "./ProductTableItemData.scss";

export interface ProductTableItemDataProps {
    readonly t : TranslationFunction;
    readonly className? : string;
    readonly button? : string;
    readonly item : ProductTableItemDataModel;
    readonly dark? : boolean;
}

export function ProductTableItemData ( props : ProductTableItemDataProps ) {
    const t = props?.t;
    const dark = props?.dark ?? false;
    const className = props?.className;
    const myItem : ProductTableItemDataModel = props?.item;
    const id : number = myItem.id;
    const mainTitle : string = myItem.mainTitle;
    const titles : readonly string[] = myItem.title;
    const products : readonly any[] = myItem.product;

    let productData : {[key: string]: { [key2: string]: any }} = {};
    forEach(titles, (title : string, index: number) => {
        forEach(products, (values, productIndex: number) => {
            const key2 = `${productIndex}`;
            if (!has(productData, key2)) {
                productData[key2] = {};
            }
            const id = `${values[index]?.category}_${values[index]?.id}`;
            productData[key2][id] = values[index]?.value;
        });
    });

    return (
        <>
            { titles.length ? (
                <>

                    <tr
                        className={ `${
                            PRODUCT_TABLE_ITEM_DATA_CLASS_NAME
                            + ' ' + PRODUCT_TABLE_ITEM_DATA_CLASS_NAME + '-main-title-row'
                            + (className ? ' ' + className : '')
                            + (dark ? ' ' + PRODUCT_TABLE_ITEM_DATA_CLASS_NAME + '-dark' : '')
                        }` }
                    >
                        <th className={ `${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-header ${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-main-title` }
                            colSpan={1 + products.length}
                        >{ t( mainTitle ) }</th>
                    </tr>

                    {map(titles, (title: string, index: number) => {
                        return (
                            <tr
                                key={ `${ id }_${ mainTitle }_${title}_tr` }
                                className={ `${
                                    PRODUCT_TABLE_ITEM_DATA_CLASS_NAME
                                    + (className ? ' ' + className : '')
                                    + (dark ? ' ' + PRODUCT_TABLE_ITEM_DATA_CLASS_NAME + '-dark' : '')
                                }` }
                            >
                                <th className={ `${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-header` }>
                                    <div className={ `${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-header-content` }>
                                        <div className={ `${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-header-content-right` }>
                                            <div className={ `${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-header-content-right-content` }>{
                                                t( title ?? "" )
                                            }</div>
                                        </div>
                                    </div>
                                </th>
                                { products.length
                                    ? (
                                        products.map( ( values, productIndex ) => {

                                            const currentValue = values[index];
                                            const nextDifferentIndex : number = findIndex(
                                                products,
                                                (nextValues) : boolean => !isEqual(currentValue?.value, nextValues[index]?.value),
                                                productIndex + 1
                                            );
                                            const colsSpan : number = nextDifferentIndex > 0 ? nextDifferentIndex - productIndex : products.length - productIndex;
                                            // console.log(`WOOT: `, id, currentValue?.value, ' productIndex=', productIndex, ' nextDifferentIndex=', nextDifferentIndex, colsSpan);

                                            if ( productIndex !== 0 && isEqual(currentValue?.value, products[productIndex - 1][index]?.value)) {
                                                return null;
                                            }

                                            return (
                                                <td
                                                    className={ `${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-product` }
                                                    key={ `${ id }_${ mainTitle }_${title}_${ productIndex }_td` }
                                                    colSpan={colsSpan}
                                                >{ values ? (
                                                    <div className={ `${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-product-content` }>
                                                        <div className={ `${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-product-feature` }>
                                                            <ProductFeatureData
                                                                t={ t }
                                                                value={ currentValue }
                                                                dark={ dark }
                                                                translationParams={productData[`${productIndex}`]}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null }</td>
                                            );
                                        })
                                    ) : (
                                        <td className={ `${ PRODUCT_TABLE_ITEM_DATA_CLASS_NAME }-content-loading` }>
                                            <Loader />
                                        </td>
                                    )
                                }
                            </tr>
                        );
                    })}

                </>
            ) : null }

        </>
    );
}
